import { render, staticRenderFns } from "./SupplierForm.vue?vue&type=template&id=3cd106a0&scoped=true&"
import script from "./SupplierForm.vue?vue&type=script&lang=js&"
export * from "./SupplierForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierForm.vue?vue&type=style&index=0&id=3cd106a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd106a0",
  null
  
)

export default component.exports